<template>
	<span>
		<mdb-row>
			<mdb-card-group deck>
 
				<mdb-card v-for="(el,ky) in interactive_block" class="card-image" :style="'background-image: url('+CONTENT_DOMAIN+'/'+el['imagepath']+')'" :key="ky">
					<mdb-view hover>
						<a href="#!">
							<!--<mdb-card-image class="view-img"  :src="CONTENT_DOMAIN+'/'+el['imagepath']" :alt="el['heading']"></mdb-card-image>-->
							<mdb-mask flex-center waves overlay="white-slight"></mdb-mask>
						</a>
					</mdb-view>
					<mdb-card-body class="back-light text-white">
						<mdb-card-title v-html="el['heading']"></mdb-card-title>
						<mdb-card-text class="text-white" v-html="el['content']"></mdb-card-text>
	
					</mdb-card-body>
					<mdb-card-footer class="text-muted back-light">
						<mdb-btn mt-auto color="primary" class="mt-0 mb-0">more</mdb-btn>
					</mdb-card-footer>	
				</mdb-card>
		
			</mdb-card-group>
		</mdb-row>
</span>
</template>

<script>
import {CONTENT_DOMAIN} from '@/constants/general_constants'
  import axios from 'axios'
  import {  mdbCard, mdbCardImage, mdbCardHeader, mdbCardBody, mdbCardTitle, mdbCardText, mdbCardFooter, mdbCardUp, mdbCardAvatar, mdbCardGroup, mdbBtn, mdbView, mdbMask, mdbIcon, mdbRow } from 'mdbvue'
  export default {
		name: 'CardGroupFeatured',
		data() {
        return {
            interactive_block: [],
            CONTENT_DOMAIN:this.$store.state.CONTENT_DOMAIN            
        };        
    },
    components: {
      mdbCard,
      mdbCardImage,
      mdbCardHeader,
      mdbCardBody,
      mdbCardTitle,
      mdbCardText,
      mdbCardFooter,
      mdbCardUp,
      mdbCardAvatar,
      mdbCardGroup,
      mdbBtn,
      mdbView,
      mdbMask,
      mdbIcon,
     
		},
    mounted :function(){
        this.showInteractiveBlock()
	},
		methods:{
      showInteractiveBlock(){ 
          axios.get(this.$store.state.apiUrl+'/interactive_block',{
              params:{
                  id_language:this.$store.state.languageId,
                  id_company:this.$store.state.companyData['id_company']
                  
              }
          })
          .then(response => {
              response = response.data
              //console.log(response);
              this.interactive_block = response;
              this.$nextTick(function () {
                
              })
              
              //console.log(this.interactive_block)
          })
          .catch(() => {
              this.interactive_block = [];
          });
      }

    }
  }
</script>

<style scoped>
.btn-primary{
    background-color: #7f867917 !important;	
}

.view-img{
    display: inline-block !important;
}		
.card-footer {
    padding: 0 0 0 0;
    background-color:transparent;
    
}
.card{
	background-repeat: no-repeat;
  background-size: cover;
  text-align: center;
	
}
.back-light{
	background-color: rgba(0, 0, 0, 0.45);
}
</style>
